export default __webpack_public_path__ + "static/spinrender-eb9f35e6d7f601bcd7056c04b47d54ed.webp";